import process from 'process';

const ENV = {
  NODE_ENV: process.env.NODE_ENV,
  NEXT_PUBLIC_LOCAL_API: process.env.NEXT_PUBLIC_LOCAL_API,
  NEXT_PUBLIC_APP_URL: process.env.NEXT_PUBLIC_APP_URL,
  NEXT_PUBLIC_DEPLOY_ENV: process.env.NEXT_PUBLIC_DEPLOY_ENV,
  S3_BUCKET: process.env.S3_BUCKET,
  IS_NG_ROK: process.env.IS_NG_ROK,
} as const;

export const CLIENT_WORKSPACE_TOKEN_COOKIE = 'clients_id_token';

export const URLS = {
  LOCAL_WEB_HOST: 'http://localhost:3000',
  LOCAL_API_HOST: 'http://localhost:3002',
  PROD_HOST: 'https://prana-club.com',
  STAGING_HOST: 'https://staging.prana-club.com',
  NGROK_HOST: 'https://prana-club-ngrok.ngrok.app',
  S3_DOMAIN: 'https://prana-club-bucket.s3.eu-central-1.amazonaws.com',
  GRAPHQL_PATH: '/api/graphql',
} as const;

const AWS = {
  BUCKET_NAME: 'prana-club-bucket',
  STAGING_BUCKET_NAME: 'prana-club-staging-bucket',
  BUCKET_HOST_NAME: 'https://prana-club-bucket.s3.eu-central-1.amazonaws.com',
  REGION: 'eu-central-1',
} as const;

const normalizeHost = (host?: string) => {
  return host?.replace(/\/+$/, '');
};

const configuredAppHost = normalizeHost(ENV.NEXT_PUBLIC_APP_URL);
const defaultBucketName = configuredAppHost?.includes('staging.') ? AWS.STAGING_BUCKET_NAME : AWS.BUCKET_NAME;

const defaultProductionHost =
  ENV.NEXT_PUBLIC_DEPLOY_ENV === 'staging' ? URLS.STAGING_HOST : URLS.PROD_HOST;

const RUNTIME_FLAGS = {
  isNgrok: ENV.IS_NG_ROK === 'true',
  isLocalApi: ENV.NEXT_PUBLIC_LOCAL_API === 'true',
  isProduction: ENV.NODE_ENV === 'production' && ENV.NEXT_PUBLIC_LOCAL_API !== 'true',
} as const;

export const WEB_HOST =
  configuredAppHost ?? (ENV.NODE_ENV === 'production' ? defaultProductionHost : URLS.LOCAL_WEB_HOST);

export const isNGRok = RUNTIME_FLAGS.isNgrok;
export const isProduction = RUNTIME_FLAGS.isProduction;

export const ORIGIN = isNGRok ? URLS.NGROK_HOST : WEB_HOST;

export const API_HOST = RUNTIME_FLAGS.isLocalApi ? URLS.LOCAL_API_HOST : isNGRok ? URLS.NGROK_HOST : WEB_HOST;

export const API_URL = `${API_HOST}${URLS.GRAPHQL_PATH}`;

export const SOCKET_IO_PORT = '3003';

export const BUCKET_NAME = ENV.S3_BUCKET?.trim() || defaultBucketName;
export const BUCKET_HOST_NAME = AWS.BUCKET_HOST_NAME;
export const REGION = AWS.REGION;
export const S3_DOMAIN = URLS.S3_DOMAIN;

export const GA_ID = {
  MAIN: 'UA-153352603-1',
  LANDING_SPEEDREADING_FOR_ADULTS: 'UA-153352603-2',
} as const;

export const IS_SSR = typeof window === 'undefined';
